<template>
  <of-dialog
    :title="detailTital"
    @onCancel="cancel"
    @onConfirm="confirm"
    width="800px"
    :append-to-body="true"
  >
    <div slot="content">
      <div class="el-dialog-div">
        <el-form
          label-width="100px"
          ref="detailForm"
          :model="detailForm"
          :rules="materialsRules"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="物品名称：" prop="MaterialName">
                <el-input
                  v-model="detailForm.MaterialName"
                  clearable
                  placeholder="请输入物品名称"
                  maxlength="20"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="品牌：" prop="MaterialType">
                <el-input
                  v-model="detailForm.MaterialType"
                  clearable
                  placeholder="请输入品牌"
                  maxlength="20"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="规格：" prop="Unit">
                <el-input
                  v-model="detailForm.Unit"
                  clearable
                  placeholder="请输入规格"
                  maxlength="20"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单价：" prop="UnitPrice">
                <el-input
                  type="Number"
                  v-model="detailForm.UnitPrice"
                  clearable
                  placeholder="请输入单价"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="数量：" prop="Number">
                <el-input
                  type="Number"
                  v-model="detailForm.Number"
                  clearable
                  placeholder="请输入数量"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="上传图片：" prop="pictureList">
            <p>支持png/jpg/jpeg格式，只能上传1张，建议尺寸350X350</p>
            <of-upload
              class="upload-demo"
              list-type="picture-card"
              @onPreview="onPreview"
              @onRemove="onRemove"
              @onUpLoad="onUpLoad"
              @onExceed="onExceed"
              :limit="1"
              :fileList="pictureList"
              :class="{ hidePic: hidePic }"
              accept="image/jpeg, image/gif, image/png, image/jpg"
            >
              <div slot="content">
                <i slot="default" class="el-icon-plus"></i>
              </div>
            </of-upload>
            <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
export default {
  name: "detail",
  props: {
    detailForm: {
      type: Object,
      default: null,
    },
    detailTital: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      //表单校验
      materialsRules: {
        MaterialName: {
          required: true,
          message: "请输入物品名称",
          trigger: "blur",
        },
        UnitPrice: {
          required: true,
          message: "请输入物品名称",
          trigger: "blur",
        },
        MaterialType: {
          required: true,
          message: "请输入品牌类型",
          trigger: "blur",
        },
        Number: {
          required: true,
          message: "请输入数量",
          trigger: "blur",
        },
        Picture: {
          required: true,
          message: "请上传物资图片",
          trigger: "blur",
        },
        Unit: {
          required: true,
          message: "请输入单位",
          trigger: "blur",
        },
      },
      width: "60%", //弹窗宽度
      dialogVisible: false, //预览控制
      dialogImageUrl: "", //预览url
      pictureList: [], //上传数组
      hidePic: false, //上传按钮控制
    };
  },
  mounted() {
    this.getImg();
  },
  components: {
    OfDialog,
    OfUpload,
  },
  methods: {
    //上传删除
    onRemove() {
      this.detailForm.Picture = null;
      this.hideUploadEdit = false;
      this.hidePic = false;
    },
    //上传预览
    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //上传
    onUpLoad(file) {
      if (file.response.Code === 0) {
        this.detailForm.Picture = file.response.Data.FileId;
        this.hidePic = true;
        this.$message({
          message: "上传图片成功",
          type: "success",
        });
      }
    },
    //上传数量检验
    onExceed() {
      this.$message({
        message: `只能选择 ${this.limitNum} 个文件`,
        type: "error",
      });
    },
    //提交
    confirm(data) {
      this.$refs.detailForm.validate((valid) => {
        if (valid) {
          this.$emit("detailFormCallBack", this.detailForm);
        }
      });
    },
    cancel() {
      this.$emit("detailFormCallBack", null);
    },
    //加载图片
    getImg() {
      if (
        this.detailForm.Picture === undefined ||
        this.detailForm.Picture === null
      ) {
        return;
      }
      this.$http
        .get("/Sys/File/Download?Id=" + this.detailForm.Picture)
        .then((res) => {
          let pictureList = [res.config];
          this.pictureList = pictureList.map((item) => {
            return {
              url: item.url,
            };
          });
          this.hidePic = true;
        });
    },
  },
};
</script>
<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.el-dialog-div {
  max-height: calc(100vh - 300px);
  overflow: auto;
}
</style>
<style>
.hidePic .el-upload--picture-card {
  display: none !important;
}
</style>
